<template>
  <input
    :placeholder="placeholder"
    @blur="fieldBlur"
    @focus="fieldFocus"
    v-on:keydown="fieldKeyDown"
    :class="inputClass"
    :id="elementIdRandom"
  />
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    inputStyle: {
      type: Object
    },
    inputClass: {
      type: Array
    },
    placeholder: {
      type: String,
      default: "Please enter the address here"
    },
    value: {
      type: String
    },
    fieldName: {
      type: String
    }
  },
  data() {
    return {
      location: {
        address: "",
        lat: "",
        lng: ""
      },
      styleObject: this.inputStyle,

      elementIdRandom:
        "autocomplete" +
        Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, "")
          .substr(0, 5),
      autocompleteOptions: {
        types: ["geocode"],
        componentRestrictions: { country: "nz" }
      }
    };
  },
  methods: {
    autocompleteFilled() {
      const place = this.$autocomplete.getPlace();
      if (place) {
        this.location.address = place.formatted_address;
        if (place.geometry && place.geometry.location) {
          this.location.lat = place.geometry.location.lat();
          this.location.lng = place.geometry.location.lng();
        } else {
          this.location.lat = "";
          this.location.lng = "";
        }
        this.$emit("location-changed", this.location);
      }
    },

    fieldBlur() {
      this.$emit("fieldBlur");
    },

    fieldFocus() {
      this.$emit("fieldFocus");
    },

    fieldKeyDown() {
      this.$emit("fieldKeyDown");
    }
  },
  mounted() {
    this.initializeAutocomplete();
  },
  methods: {
    initializeAutocomplete() {
      this.$nextTick(() => {
        this.$autocomplete = new google.maps.places.Autocomplete(
          document.getElementById(this.elementIdRandom),
          this.autocompleteOptions
        );
        this.$autocomplete.addListener("place_changed", this.autocompleteFilled);
      });
    },
    autocompleteFilled() {
      const place = this.$autocomplete.getPlace();
      if (place) {
        this.location.address = place.formatted_address;
        if (place.geometry && place.geometry.location) {
          this.location.lat = place.geometry.location.lat();
          this.location.lng = place.geometry.location.lng();
        } else {
          this.location.lat = "";
          this.location.lng = "";
        }
        this.$emit("location-changed", this.location);
      }
    },
    fieldBlur() {
      this.$emit("fieldBlur");
    },
    fieldFocus() {
      this.$emit("fieldFocus");
    },
    fieldKeyDown() {
      this.$emit("fieldKeyDown");
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.location.address = newVal;
      this.location.lat = newVal;
      this.location.lng = newVal;
    }
  }
};
</script>

<style scoped>
/* Add your custom styles here */
</style>
